import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { logout } from '../../actions';

// const debug = require('debug')('cambria:Logout');


class Logout extends Component {
  componentWillMount() {
    this.props.logout();
  }
  render() {
    return (
      <div className="Logout">
        {this.props.authToken ? (
          <p>Logging out...</p>
        ) : (
          <Redirect to="/" />
        )}
      </div>
    );
  }
}


const mapStateToProps = state => ({
  authToken: state.authToken,
});

const mapDispatchToProps = {
  logout,
};


export default connect(mapStateToProps, mapDispatchToProps)(Logout);



// WEBPACK FOOTER //
// ./src/components/Logout/index.js